module.exports = __webpack_public_path__ + "static/media/Background1.9cf4bc23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/Background1.jpg
// module id = 81
// module chunks = 0